// Import for modals
import React from "react";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import close_modal from "./../../../assets/ic_close_wh.svg";
import "react-table/react-table.css";
import "react-table-hoc-fixed-columns/lib/styles.css";

// Imports for React Table
import Pagination from "../../../common/Pagination/Pagination";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import find from "lodash/find";
import { Button } from "../../../common/Button/Button";
import { toast } from 'react-toastify';
import copysvg from "../../../assets/arrow_copy.svg"

// Imports for Filter sections
import Select from "react-select";
import Spinner from '../../../common/Spinner/Spinner';
import MultiSelectAll from '../../../common/Multiselect/MultiSelectAll';
import { ControlledInput } from '../../../common/Input/Input';
import Checkbox from '../../../common/Checkbox/Checkbox';
import ReactDatePicker from "react-datepicker";

// Import API
import api from "../../../utils/api";

// Import React Table
const ReactTableFixedColumns = withFixedColumns(ReactTable);

// Whatsapp Message Data Display Content
export default function ViewWhatsappMessagesModal(props) {
    const [data, setData] = useState(null);
    const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
        value: "10",
        label: "10",
    });

    const copyToClipboard = (content) => {
        const el = document.createElement('textarea');
        el.value = content;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

    // format date to dd/mm/yyyy
    function formatDate(dtCreated) {
        console.log(dtCreated, ">>>dtCreated in formatDate function");

        const date = typeof dtCreated === 'string' ? new Date(dtCreated) : dtCreated;

        if (isNaN(date)) return "Invalid Date";

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        const formattedDate = `${day}/${month}/${year}`;

        return formattedDate;
    }

    const columns = [
        {
            id: "sServiceDisplayName",
            Header: "Service Id",
            width:180,
            // flex:1,
            headerStyle: { 'whiteSpace': 'normal', 'borderBottom': 'solid 1px #ccc' },
            accessor: "sServiceDisplayName",
            Cell: ({ original }) => (
                <div className='text-center'>
                    {/* <span className='conv-text-center' style={{ whiteSpace: 'pre-wrap' }}>
                        {
                            (original.sServiceCode === "MKTLINKAGEEXHIBITION" || original.sServiceCode === "MKTLINKAGEBULKBUYER" ||
                                original.sServiceCode === "MKTLINKAGEECOM" || original.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
                                original.sServiceCode === "MKTLINKAGESHOPINSHOP" || original.sServiceCode === "MKTLINKAGEEXPORT") && original.sServiceDisplayName ?
                                // original.sServiceName ?
                                //     original.sServiceName + " " + `(${original.sServiceDisplayName})` :
                                //     original.refServiceType ?
                                //         original.refServiceType.sServiceName + " " + `(${original.sServiceDisplayName})` :
                                //         ""
                                original?.sServiceDisplayName
                                :
                                original.sServiceName ?
                                    original.sServiceName :
                                    original.refServiceType ?
                                        original.refServiceType.sServiceName :
                                        ""
                        }
                    </span> */}
                    <div>
                        <span style={{
                            color: "#76287C"
                        }} className='mt-2 conv-mr18 lpm-service-grid-key text-center'>
                            {
                                original.sMessageType == "Cancellation" ?
                                    original.nResourceInstanceId
                                    :
                                    "NA"
                            }
                        </span>
                    </div>
                </div>
            ),
        },
        {
            id: "sFirstName",
            Header: "Customer Name",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
            accessor: "sFirstName",
            Cell: ({ original }) => (
                <div className='text-center'>
                    {
                        `${original.sFirstName ?
                            original.sFirstName :
                            original.customer_meta ?
                                original.customer_meta.first_name :
                                ""
                        }${' '}
            			${original.sLastName ?
                            original.sLastName :
                            original.customer_meta ?
                                original.customer_meta.last_name :
                                ""
                        }`
                    }
                </div>
            ),
        },
        {
            id: "sContactNumber",
            Header: "Phone No.",
            width: 200,
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
            accessor: "sContactNumber",
            Cell: ({ original }) => (
                <div className='text-center'>
                    {/* <span onClick={() => getUserDetails(original)}>
            		{
            			original.sContactNumber
            		}
            		</span> */}

                    <span>
                        {
                            original.sContactNumber
                        }
                    </span>
                    <img
                        alt="copy"
                        src={copysvg}
                        height={"20px"}
                        width={"16px"}
                        className="con-cursor-pointer conv-mr13 conv-ml10"
                        onClick={(e) => {
                            e.preventDefault();
                            copyToClipboard(original.sContactNumber);
                            toast(`${original.sFirstName ?
                                original.sFirstName :
                                original.customer_meta ?
                                    original.customer_meta.first_name :
                                    ""
                                }${' '}
            				${original.sLastName ?
                                    original.sLastName :
                                    original.customer_meta ?
                                        original.customer_meta.last_name :
                                        ""
                                }'s Contact Copied!`, {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                        }}
                    />
                </div>
            )
        },
        {
            id: '',
            Header: 'Message Sent Date',
            width: 220,
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
            accessor: "dtCreated",
            Cell: ({ original }) => (
                // console.log(original, ">>> original in creted on row cell")

                <div className='text-center'>
                    {
                        original.dtCreated ? formatDate(original?.dtCreated) : ""
                    }
                </div>
                // <Button className="con-btn-filled" 
                // // onClick={() => handleEnterRevenueClick()}
                // >Enter Revenue</Button>
            )
        },
        {
            id: "sTemplateName",
            Header: "Message",
            flex: 2,
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
            accessor: "sTemplateName",
            Cell: ({ original }) => (
                <div className='text-center cell-content'>
                    {original?.sTemplateName}
                </div>
            ),
        }
    ]

    
    console.log(props, ">>> props in viewWhatsappMessagesModal");
    console.log(data, ">>> data");
    console.log(props?.data, ">>>>All messages in ViewWhatsappMessagesModal");
    
    return (
        <Modal
            isOpen={props.isOpen}
            // onRequestClose={props.toggleModal}
            ariaHideApp={false}

        >
            <ModalContent className="view-whatsapp-message-modal">
                <div className="modal-header">
                    <span className="modal-title">Whatsapp Cancellation Messages</span>
                    <img
                        alt="close"
                        id="Close"
                        src={close_modal}
                        className="close modal-close"
                        onClick={() => {
                            props.toggleModal()
                        }}
                    />
                </div>

                {/* FILTERS */}
                <div
                    className="row"
                    style={{
                        marginBottom: '5px',
                        boxShadow: "0 5px 10px -2px rgba(0, 0, 0, 0.5)",
                        paddingBottom: "10px",
                    }}
                >
                    <div className="col-12" style={{backgroundColor:""}}>
                        <div className="row">
                        {/* Filter Items with col-2 width */}
                        <div className="col-9" style={{backgroundColor:"", paddingLeft:"7px"}}>
                            <div className="row">
                                <div className="col ml-5 mt-3 spled-container conv-zindex">
                                    <Select
                                    options={props?.oppTypeNameListWpModal}
                                    onChange={props?.onOppTypeChange}
                                    value={props?.selectedOppType}
                                    placeholder="Select Opp Type"
                                    isClearable
                                    />
                                </div>

                                <div className="col mt-3 spled-container conv-zindex">
                                    <MultiSelectAll
                                    toggleAll={props?.toggleAllOppTitle}
                                    toggleSelection={props?.onOppTitleChange}
                                    checkboxItemsList={props?.oppTitleNameListWpModal}
                                    selectedOptions={props?.selectedOppTitleWpModal}
                                    placeholderButtonLabel="Select Opp Title"
                                    />
                                </div>

                                <div className="col mt-3 spled-container conv-zindex">
                                    <div className="width-100">
                                        <ReactDatePicker
                                            dateFormat="dd/MM/yyyy"
                                            selected={props.fromDate}
                                            // onChange={(date) => props.onDateRangeChange("fromDate", date)}
                                            // onChange={(date) => {
                                            //     if(date > new Date()){
                                            //         let nowDate = formatDate(new Date())

                                            //         toast(String(`From-Date can't be greater than ${nowDate}`), {
                                            //             autoClose: 5000,
                                            //             type: toast.TYPE.ERROR,
                                            //         });
                                            //     }else{
                                            //         props.setFromDate(date)
                                            //     }
                                            // }}
                                            onChange={(date) => props.handleFromDate(date)}
                                            placeholderText="From Date"
                                            maxDate={new Date()}
                                            // maxDate={props?.toDate ? props.toDate : new Date()}
                                        />
                                    </div>
                                </div>

                                <div className="col mt-3 spled-container conv-zindex" >
                                    <div className="width-100">
                                        <ReactDatePicker
                                            dateFormat="dd/MM/yyyy"
                                            selected={props.toDate}
                                            // onChange={(date) => props.setToDate(date)}
                                            onChange={(date) => props.handleToDate(date)}
                                            // onChange={(date) => {
                                            //     if(date > new Date()){
                                            //         let nowDate = formatDate(new Date())
                                            //         toast(String(`To-Date can't be greater than ${nowDate}`), {
                                            //             autoClose: 5000,
                                            //             type: toast.TYPE.ERROR,
                                            //         });
                                            //     }else{
                                            //         props.setToDate(date)
                                            //     }
                                            // }}
                                            placeholderText="To Date"
                                            maxDate={new Date()}
                                            // maxDate={props?.fromDate}
                                            minDate={props?.fromDate ? props?.fromDate : null}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        

                        {/* Search Button taking up remaining space, aligned to end */}
                        <div className="col d-flex align-items-center justify-content-end mt-3 spled-container conv-zindex pr-5 flex-gap-3" style={{backgroundColor:""}}>
                                <div className="col spled-container">
                                    <Select
                                    options={props?.messageTypeOptions}
                                    onChange={props?.onMessageTypeChange}
                                    value={props?.selectedMessageType}
                                    placeholder="Select Message Type"
                                    isClearable
                                    />
                                </div>
                        </div>
                        </div>
                    </div>

                    <div className="col-12" style={{backgroundColor:""}}>
                        <div className="row">
                            {/* Search Button taking up remaining space, aligned to end */}
                            <div className="col d-flex align-items-center justify-content-end mt-3 spled-container pr-5 flex-gap-3 mr-3" style={{backgroundColor:""}}>
                                <Button
                                style={{ height: '37px' }}
                                className="con-btn-filled"
                                onClick={props.searchFilterWpSendCacellationMessages}
                                >
                                Get Messages
                                </Button>

                                <Button
                                style={{ height: '37px' }}
                                className="con-btn-filled"
                                onClick={props.clearSearchFilterWpCancellationMessages}
                                >
                                Clear
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>


                {/* Main Table */}
                <div className="col-12 conv-mt15 conv-pl40 conv-pr40 spled-container fix-filter" style={{backgroundColor:""}}>
                    <div className="spled-container">
                        <div className={`service-partner spled-container, ${props?.wpCancellationMessageIsLoading && "set-opacity"}`}>
                        {props.wpCancellationMessageIsLoading && <Spinner className="center-screen" />}
                            {/* <ReactTableFixedColumns
                                minRows={0}
                                data={props?.data || []}
                                columns={columns}
                                // manual
                                // defaultPage={props.page}
                                // pages={props.pages}
                                // page={props.page}
                                pageSize={props.pageSize} // complete length of data to display
                                sortable={false}
                                // defaultPageSize={10}
                                showPagination={false}
                                // pageSizeOptions={[10, 20, 30, 50, 75, 100]}
                                // onFetchData={(state, instance) => {
                                //     props.onFetchServiceRequests(instance, false);
                                // }}
                                // onPageSizeChange={(option)=>{
                                //     setSelectedPageSizeOption(option)
                                // }}
                                // PaginationComponent={Pagination}
                                // PaginationComponent={(paginationProps) => (
                                //     <Pagination
                                //         {...paginationProps}
                                //         displayRecordCount={props?.displayRecordCount}
                                //     />
                                // )}
                                style={{ overflowY: "initial", height: "390px" }}
                                className="-striped hide-scrollbar"
                            /> */}


                            {<ReactTableFixedColumns
                                                minRows={0}
                                                data={props?.data || []}
                                                columns={columns}
                                                manual
                                                defaultPage={props?.page}
                                                pages={props?.pages}
                                                page={props?.page} // purple colors the selected page
                                                // isTotalRecords = {true}
                                                pageSize={props?.pageSize}
                                                defaultPageSize={10}
                                                showPagination={true}
                                                pageSizeOptions={[10,20,30,50,75,100]}

                                                onFetchData={(state, instance) => {
                                                    console.log(state.page, ">>>state On onFetchData ran....");
                                                    console.log(instance, ">>>>instance on onFetchData ran");
                                                    props?.handleViewMessageOnFetchData(state);
                                                    // setcurrentPage(state?.page ? state?.page : 0) // when page changes an api is called with the current pagge + 1
                                                }}
                                                onPageSizeChange={props.onViewMessagePageSizeOptionChange}
                            
                                                // mycode
                                                // expanded={expandedRows}
                                                // onExpandedChange={(newExpanded, index, event, row) => {
                                                //     if (newExpanded[index[0]] === false) {
                                                //         newExpanded = {}
                                                //     } else {
                                                //         Object.keys(newExpanded).map(k => {
                                                //             newExpanded[k] = parseInt(k) === index[0] ? {} : false
                                                //         })
                                                //     }
                                                //     setExpandedRows(newExpanded)
                                                // }}
                                                
                                                PaginationComponent={(paginationProps) => (
                                                    <Pagination
                                                        {...paginationProps}
                                                        // displayRecordCount={props?.displayRecordCount}
                                                />
                                                )}
                                                style={{ overflowY: "initial", height: "350px" }}
                                                // handlePageChange={handlePageChange}
                                                className="-striped"
                                            />}
                        </div>
                    </div>
                </div>
            </ModalContent>
        </Modal>
    );
}
